import React, { useState } from 'react'
import './index.scss'
import { Box, IconButton, Typography } from '@mui/material'
import AvahSideBarImage from 'assets/img/AvahSideBarImage.png'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import { generateInvoicePdf } from './invoicePdf'

/**
 * Was: render the whole invoice into a hidden off-screen DOM, screenshot it with
 * html2canvas, and paste the bitmap into a PDF. That produced a blurry ~72 DPI
 * JPEG, and because the "table cells" were disabled MUI text inputs, the invoice
 * came out covered in grey rounded boxes.
 *
 * Now the PDF is drawn directly with jsPDF vector primitives (see invoicePdf.js):
 * real text, sharp at any zoom, selectable, and far smaller. No hidden DOM, and
 * no dependency on html2canvas (which wasn't even declared in package.json — it
 * only resolved transitively through jsPDF).
 */
const PDF = ({ spareData, labourData, rowData }) => {
  const [busy, setBusy] = useState(false)

  const handleClick = async () => {
    if (busy) return
    setBusy(true)
    try {
      await generateInvoicePdf({
        rowData,
        spareData,
        labourData,
        logoSrc: AvahSideBarImage,
        businessName: localStorage.getItem('business_name') || '',
      })
    } catch (e) {
      console.error('Invoice PDF generation failed:', e)
    } finally {
      setBusy(false)
    }
  }

  return (
    <IconButton color='options' onClick={handleClick} disabled={busy}>
      <Box className='flex ai-flex-start jc-center column'>
        <Typography fontSize={9}>PDF</Typography>
        <PictureAsPdfIcon style={{ cursor: 'pointer', marginRight: '5px' }} />
      </Box>
    </IconButton>
  )
}

export default PDF
